export class selectControlModel {
    public constructor(
        public value: number = 0,
        public name: string = ""
    ) {

    }
}
